<template>
    <div class="page egiftPage myWallet epay">
        <form @submit.prevent="buyMySelf">
            <div class="container">
                <div class="title h1"> Reload my Kettleman’s Card </div>
                <div class="flexWrap">
                    <div class="mainFrame">
                        <img v-if="gcard.imgDef" :src="gcard.imgDef" alt="">
                    </div>
                    <div class="righySide">
                        <GiftCardAmount :gcard="gcard"/>
                    </div>
                </div>
    
                
                <div class="h1">Your payment information</div>
                <div class="flexWrapDesk">
                    <div class="paymentInfo">
                        <div class="h3">Payment info</div>
                        <CartPaymentsOption :no-title="true" :for-gift-cards="true"/>
                    </div>
                </div>
                
                <div class="bntBox">
                    <button class="smlBtn zbg">
                        Confirm
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import GiftCardAmount from "../../components/checkout/GiftCardAmount";
    import CartPaymentsOption from "../../components/checkout/CartPaymentsOption";

    export default {
        name: 'Egifts',
        components: {GiftCardAmount, CartPaymentsOption},
        data() {
            return {
                gcard: {
                    type_id: 1996,
                    description: "",
                    recipient_email: null,
                    recipient_name: null,
                    recipient_fname: null,
                    recipient_lname: null,
                    purchaser_email: null,
                    purchaser_name: null,
                    purchaser_lname: null,
                    purchaser_fname: null,
                    amount: '25',
                    custom_ammount: 0,
                    theme_index: null
                },
                giftTypeList: null
            }
        },
        created() {
            if(this.giftCardData.my_wallet === false){
                this.$store.commit("giftcard/resetGcart");
                this.giftCardData.my_wallet = true;
            }
            this.$store.commit("shared/setTopBar", {title: "My Wallet", showBackButton: false, showBag: false}, {root: true});
            this.gcard.theme_index = 0;
            this.gcard.imgDef = "https://ccp.mobileappsuite.com/assets/images/gift_card_types/1996/image_2x.png",
            this.gcard.purchaser_fname = this.user.first_name;
            this.gcard.purchaser_lname = this.user.last_name;
            this.gcard.purchaser_email = this.user.email;
            
            if (this.user) {
                this.contact_info.name = this.user.first_name + " " + this.user.last_name;
                this.contact_info.fname = this.user.first_name;
                this.contact_info.lname = this.user.last_name;
                this.contact_info.email = this.user.email;
                this.contact_info.phone = this.user.country_code + this.user.phone;
                this.giftCardData.purchaser.user_id = this.user.member_id;
            }
            this.$store.dispatch("shared/getGatewayInfo",{giftcardTypeId: this.gcard.type_id})
        },
        methods: {
            buyMySelf() {
                if (this.gcard.amount == 'custom') {
                    this.gcard.amount = this.gcard.custom_ammount;
                }
                if (this.gcard.amount == 0) {
                    this.$store.commit("shared/setAlert", "Please select a gift card amount");
                    return false;
                }

                this.contact_info.name = this.contact_info.fname + " " + this.contact_info.lname

                let payment = {
                    card_number: this.cart.card.credit_card_number,
                    credit_card_id: this.cart.card.credit_card_id,
                    gateway_id: this.gatewayInfo.gateway_id,
                    business_id: 1329
                }
                this.$store.commit("giftcard/setPaymentInfo", payment);
                this.$store.commit("giftcard/addGiftCard", this.gcard);
                
                this.$modal.show("promt-modal", {
                    title: "Warning!", content: "Are you sure you wan to complete this transaction?", success: () => {
                        if(this.$route.params.cardId){
                            this.$store.dispatch("giftcard/refillGiftCard", {
                                data:{
                                    amount: this.gcard.amount,
                                    gift_card_id: this.$route.params.cardId,
                                    payment_method : "credit_card",
                                    payment_data : this.$store.state.cart.cart.card.credit_card_id
                                },
                                callback: (cards) => {
                                    this.$router.push({name: 'EgiftThanks',query: {wallet:"true"}});
                                    setTimeout(()=>{
                                        this.$store.commit("giftcard/resetGcart");
                                        this.$store.commit("cart/resetCart");
                                    },1100)
                                }
                            });
                        }else{
                            this.$store.dispatch("giftcard/buyForMyselfGiftCard",{
                                callback: (cards) => {
                                    this.$router.push({name: 'EgiftThanks',query: {wallet:"true"}});
                                    setTimeout(()=>{
                                        this.$store.commit("giftcard/resetGcart");
                                        this.$store.commit("cart/resetCart");
                                    },1100)
                                }
                            });
                        }
                    }
                })
                
                return false;
            },
        },
        computed: {
            giftCardData(){
                return this.$store.state.giftcard.giftCardData
            },
            contact_info(){
                return this.$store.state.giftcard.giftCardData.contact_info
            },
            gatewayInfo(){
                return this.$store.state.shared.gatewayInfo
            },
            cart(){
                return this.$store.state.cart.cart
            }
        }
    }
</script>
